import React, { Component } from "react";
import axios from "axios";
import Serverurl from "./Apiurl";
import {
  TextField,
  Button,
  Alert,
  Collapse,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Autocomplete from "@mui/material/Autocomplete";
import EditIcon from "@mui/icons-material/EditSquare";
import DeleteIcon from "@mui/icons-material/Delete";
import { Navigate } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import {InputAdornment} from "@mui/material";
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import MarginIcon from '@mui/icons-material/Margin';
export default class AddProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pj_id: 0,
      name: "",
      custmername: "",
      address: "",
      contactnumber: "",
      emailid: "",
      altcontactname: "",
      phoneno: "",
      amount: "",
	    pj_margin: "", erropenwag:false,errormessagewag:'',erropenmas:false,errormessagemas:'',
      wageCategories: [],
      projectWages: [],
      selectedCategory: "",
      selectedAmount: "",
	  wageCategoryarray: [],
wageCategoryarrauto: [],
selectedWageCategory: null,
	  redirect: false,
pagename: "",
selectedWageEditIndex: undefined,
selectedMastri:[],  selectedvenid: "",
vendorMastriAuto: [],Asignmastri:[],

      errormessage: "",
      erropen: false,
    };
  }
  
  
  componentWillMount() { 
		if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Enter Project";   
			 this.props.parentsCallback(
           strname
        );
		
		document.title = "VR Builders - Projects";
	
  const id = window.location.pathname.split("/").pop();
  this.getWageCategories(() => {
    if (id && id !== "addnewproject") {
      this.setState({ pj_id: id }, () => {
        this.getProjectData(id);
      });
    } else {
   
      this.setState({
        projectWages: [
          { wc_id: 4, amount: "1000" },
		   { wc_id: 5, amount: "1000" }
        ]
      });
	  
	  this.setState({
        Asignmastri: [
          { am_id: 0, am_name: "" ,am_active:"",am_new:"0"},
		
        ]
      });
	  this.onloadWagesbind();
    }
  });
	
  
}

onloadWagesbind()
{
	
	 axios
    .get(Serverurl + "ajaxadminoption.php?action=getall")
    .then((resp) => {
      if (resp.data.length > 0) {
		  
		  const projectWages = [
		   { wc_id: 0, amount: 0,wc_categoryname:'' },
    { wc_id: 4, amount: resp.data[1].ao_value,wc_categoryname:resp.data[1].ao_name},
    { wc_id: 5, amount: resp.data[0].ao_value,wc_categoryname:resp.data[0].ao_name }
  ];

this.setState({ projectWages });  
	  }
	  
	});
	
	
	
}

  getWageCategories(callback) {
  axios
    .get(Serverurl + "ajaxprojects.php?action=getallwagecategoryautoextender&wc_categoryname=")
    .then((resp) => {
      if (resp.data.length > 0) {
        this.setState(
          { wageCategories: resp.data },
          () => {
            if (callback) callback();
          }
        );
      }
    });
}
  // GET PROJECT DATA (EDIT MODE)
getProjectData(id) {
  axios
    .get(Serverurl + "ajaxprojects.php?action=getall&pj_id=" + id)
    .then((resp) => {
      if (resp.data.length > 0) {
        const d = resp.data[0];
        let wages = [];
        if (d.wage_data) {
          wages = d.wage_data.split("`").map((item) => {
            const [wc_id, amount] = item.split("~");
            return {
              wc_id: wc_id,
              amount: amount,
            };
          });
        }
		let mastri = [];
if (d.assign_mastri) {
  mastri = d.assign_mastri.split("`").map((item) => {
    const [vm_id] = item.split("~");
    return {
      vm_id: vm_id,
      title: vm_id,
    };
  });
}
        //  ADD DEFAULT MASRI IF NOT EXISTS
        const hasMastri = wages.some((w) => w.wc_id === "4");
        if (!hasMastri) {
          wages.push({
            wc_id: "4",
            amount: "1000",
          });
        }
        this.setState({
          name: d.pj_projectname,
          custmername: d.pj_customername,
          address: d.pj_address,
          contactnumber: d.pj_phoneno,
          emailid: d.pj_emailid,
          altcontactname: d.pj_altcontactperson,
          phoneno: d.pj_altphoneno,
          amount: d.pj_finalizedamount,
          pj_margin: d.pj_margin,
        
		 
        });
      }
	  this.getwagesbyId(id);
    });
	
}

getwagesbyId(id)
{
	axios
    .get(Serverurl + "ajaxprojects.php?action=wagesbyprojid&orderby=wc_id&pj_id=" + id)
    .then((resp) => {
      if (resp.data.length > 0) {
		 let wages = resp.data.map(item => ({
            ...item,
            wc_id: Number(item.wc_id)
        }));

        this.setState({
            projectWages: [
                { wc_id: 0, amount: 0 },
                ...wages
            ]
        });
		  
	  }
	  this.getMastribyId(id)
	});
	
}
getMastribyId(id)
{
	axios
    .get(Serverurl + "ajaxprojects.php?action=mastribyprojid&orderby=id&pj_id=" + id)
    .then((resp) => {
      if (resp.data.length > 0) {
		 let mastri = resp.data.map(item => ({
            ...item,
            am_id: Number(item.am_id)
        }));

        this.setState({
            Asignmastri: [               
          { am_id: 0, am_name: "" ,am_active:"",am_new:"0"},		    
                ...mastri
            ]
        });
		  
	  }else{
		   this.setState({
        Asignmastri: [
          { am_id: 0, am_name: "" ,am_active:"",am_new:"0"},
		
        ]
      });
	  }
	});
	
}


/* WAGE CATEGORY AUTOEXTENDER */
onloadWageCategoryBind = (event) => {
  axios
    .get(Serverurl + "ajaxprojects.php", {
      params: {
        action: "getallwagecategoryautoextender",
        wc_categoryname: event.target.value
      }
    })
    .then((resp) => {
      let arr = [];
      (resp.data || []).forEach((row) => {
        if (!arr.some((x) => x.wc_id === row.wc_id)) {
          arr.push({
            title: row.wc_categoryname,
            wc_id: row.wc_id
          });
        }
      });
      this.setState({
        wageCategoryarray: resp.data || [],
        wageCategoryarrauto: arr
      });
    });
};
onWageCategoryChange = (event, value) => {
	
  this.setState({
    selectedWageCategory: value,
    selectedCategory: value ? value.wc_id : ""
  });
};
  myChangeHandler = (event) => {
	  
	 
	    const re = /^[0-9.\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
  if(nam==="amount" || nam==="pj_margin" || nam==="contactnumber" || nam==="phoneno" )
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	  }
  }
 
    else{
  this.setState({[nam]: val});
  }

    
  };
  // WAGE HANDLERS
  handleCategoryChange = (event) => {
    this.setState({ selectedCategory: event.target.value });
  };
  handleAmountChange = (event) => {
    this.setState({ selectedAmount: event.target.value });
  };
  // ADD WAGE ROW
  addWageRow = () => {
  const {
    selectedCategory,
    selectedAmount,
    projectWages,
    selectedWageEditIndex
  } = this.state;
  if (!selectedCategory) return this.showErrorwag("Select Category");
  if (!selectedAmount) return this.showErrorwag("Enter Amount");
  //  protect Mastri
  if (selectedCategory === "Mastri") {
    return this.showErrorwag("Mastri row cannot be modified");
  }
  const newRow = {
    wc_id: selectedCategory,
    amount: selectedAmount
  };
  let updated = [...projectWages];
  if (selectedWageEditIndex !== undefined) {
    updated[selectedWageEditIndex] = newRow;
  } else {
    const index = updated.findIndex(x => x.wc_id == selectedCategory);
    if (index !== -1) {
      updated[index] = newRow;
    } else {
      updated.push(newRow);
    }
  }
  this.setState({
    projectWages: updated,
    selectedCategory: "",erropenwag:false,errormessagewag:'',
    selectedAmount: "",selectedWageCategory:'',
    selectedWageEditIndex: undefined
  });
};
  // SAVE
  handleSave = () => {
    const {
      pj_id,
      name,
      custmername,
      address,
      contactnumber,
      emailid,
      altcontactname,
      phoneno,
      amount,
      projectWages,
    } = this.state;
    if (!name) return this.showError("Enter Project Name");
    if (!custmername) return this.showError("Enter Customer Name");
	  if (!contactnumber) return this.showError("Enter Phone Number");
	   if (!emailid) return this.showError("Enter Email ID");
	     if (!altcontactname) return this.showError("Enter Alternate Contact Person");
    if (!phoneno) return this.showError("Enter Alternate Phone Number");
    
  
   
  
    if (!amount) return this.showError("Enter Amount");
	if (!address) return this.showError("Enter Address");
	
	if(projectWages.length===0)
	{
		this.showError("Please Add Project Wages");
		window.scrollTo({
          top: 0})
		return false;
	}
	if(this.state.Asignmastri.length===1)
	{
		this.showError("Please Assign Mastri");
		window.scrollTo({
          top: 0})
		return false;
	}
   const wage_data = projectWages
  .map((w) => `${w.wc_id}~${w.amount}`)
  .join(";");
  const assign_mastri = this.state.Asignmastri 
  .map((m) => `${m.am_id}~${m.am_active}`)
  .join(";");
    const formData = new FormData();
    formData.append("action", "insertorupdate");
    formData.append("pj_id", pj_id);
    formData.append("pj_projectname", name);
    formData.append("pj_customername", custmername);
    formData.append("pj_address", address);
    formData.append("pj_phoneno", contactnumber);
    formData.append("pj_emailid", emailid);
    formData.append("pj_altcontactperson", altcontactname);
    formData.append("pj_altphoneno", phoneno);
    formData.append("pj_finalizedamount", amount);
	formData.append("pj_margin", this.state.pj_margin); 
    formData.append("userid", localStorage.getItem("VRuserid"));
    formData.append("wage_data", wage_data);
	formData.append("assign_mastri", assign_mastri);
    axios.post(Serverurl + "ajaxprojects.php", formData).then((res) => {
      if (res.data === -1) {
        this.showError("Project already exists");
      } else {
        this.setState({
  redirect: true,
  pagename: "/Projects",
});
      }
    });
  };
  showError(msg) {
    this.setState({ errormessage: msg, erropen: true });
	window.scrollTo({
          top: 0})
  }
   showErrorwag(msg) {
    this.setState({ errormessagewag: msg, erropenwag: true });
	window.scrollTo({
          top: 100})
  }
//EDIT WAGE FUNCTION  
   showErrormas(msg) {
    this.setState({ errormessagemas: msg, erropenmas: true });
	window.scrollTo({
          top: 300})
  }
 editWageRow = (index) => {
  const row = this.state.projectWages[index];
  console.log(row)
  const items = {
					title:row.wc_categoryname,
					year: row.wc_id,
							 
				};

  if (row.wc_id === "4") return; //  block edit
  this.setState({
    selectedCategory: row.wc_id,
    selectedAmount: row.amount,
    selectedWageEditIndex: index,
	selectedWageCategory:items,
  });
};
//DELETE WAGE FUNCTION
deleteWageRow = (index) => {
  let row = this.state.projectWages[index];
  if (row.wc_id === "4") return; // block delete
  let updated = [...this.state.projectWages];
  updated.splice(index, 1);
  this.setState({ projectWages: updated });
};


//vendor mastri auto-extender
onloadVendorMastriBind = (event) => {
  axios
    .get(Serverurl + "ajaxprojects.php", {
      params: {
        action: "getallvendormastriautoextender",
        vm_vendorname: event.target.value,
      },
    })
    .then((resp) => {
      let arr = [];
      (resp.data || []).forEach((row) => {
        if (!arr.some((x) => x.vm_id === row.vm_id)) {
          arr.push({
            title: row.vm_vendorname,
            vm_id: Number(row.vm_id),
          });
        }
      });
      this.setState({
        vendorMastriAuto: arr,
      });
    });
};
//Vendor selection handler
onMastriChange = (event, value) => {
  this.setState({
    selectedMastri: value || [],
	selectedvenid:value ? value.vm_id : ""
  });
};

deletemastri= (index) => {
  let row = this.state.Asignmastri[index];

  let updated = [...this.state.Asignmastri];
  updated.splice(index, 1);
  this.setState({ Asignmastri: updated });
};
 handleAddMastri = () => {
  const { selectedMastri, Asignmastri,selectedvenid } = this.state;


 if (!selectedvenid){   
	
  this.showErrormas("Select Mastri");
 return false;
 
 }

  this.setState((prev) => {
	   const { selectedMastri, Asignmastri } = prev;
	  const blankRow = Asignmastri[0];
    const otherRows = Asignmastri.slice(1);
	     const newAmId = Number(selectedvenid);
		 
		
    const alreadyExists = otherRows.some(
      (item) => item.am_id !== 0 && item.am_id === newAmId
    );

    if (alreadyExists) {
      // Optionally set an error message instead of adding
      
	  
	    this.showErrormas("Mastri already added");
 return false;
    }
	  
   

    // 1. Separate the first blank row from the rest
    

    // 2. Mark all existing mastri rows as inactive
    const updatedOthers = otherRows.map((item) => ({
      ...item,
      am_active: "1",
    }));

    // 3. Add the new mastri row as active
    const existingIds = updatedOthers
      .filter((i) => i.am_id !== 0)
      .map((i) => i.am_id);

    const newId =
      existingIds.length > 0 ? Math.max(...existingIds) + 1 : 1;

    const newRow = {
      am_id: selectedMastri.vm_id,
      am_name: selectedMastri.title, // or selectedMastri.name, depending on your options
      am_active: "0",
      am_new: "0",
    };

    // 4. Rebuild the array: blank row + updated others + new row
    const updated = [blankRow, ...updatedOthers, newRow];

    return {
      Asignmastri: updated,erropenmas:false,errormessagemas:'',
      selectedMastri: null, // clear autocomplete after adding
    };
  });
};

  render() {
	   if (this.state.redirect === true) {
    return <Navigate to={this.state.pagename} />;
  }
    return (
      <>
      
        <Collapse in={this.state.erropen}>
          <Alert
            severity="error"
            action={
              <IconButton onClick={() => this.setState({ erropen: false })}>
                <CloseIcon />
              </IconButton>
            }
          >
            {this.state.errormessage}
          </Alert>
        </Collapse>
      
<div className="txtprojfrm">
<p>Name</p>
        <p>  <TextField
           className="inputcntlparent" size="small"
            name="name"
            label="Project Name"
            fullWidth
            onChange={this.myChangeHandler}
            value={this.state.name}
			
  slotProps={{
    htmlInput: {
      maxLength: 150,
      tabIndex: 1
    },
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <AccountTreeIcon  sx={{ color: "#206ccc", fontSize: 20 }} />
        </InputAdornment>
      )
    }
  }}
          />
		  </p>
		  </div>
		  
		  <div className="txtprojfrmryt">
         <p>Customer</p>
        <p> <TextField
           className="inputcntlparent" size="small"
            name="custmername"
            label="Customer"
            fullWidth
			 slotProps={{
    htmlInput: {
      maxLength: 150,
      tabIndex: 2
    },
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <PersonIcon sx={{ color: "#206ccc", fontSize: 20 }} />
        </InputAdornment>
      )
    }
  }}
            onChange={this.myChangeHandler}
            value={this.state.custmername}
          />		  </p>  </div>
		  
		  <div className="clear"></div>
		  
     
		  
		    <div className="txtprojfrm"> <p>Phone</p> 
         <p>  <TextField
            className="inputcntlparent" size="small"
            name="contactnumber"
            label="Phone"
            fullWidth
			slotProps={{
    htmlInput: {
      maxLength: 10,
      tabIndex: 3
    },
    input: {
      endAdornment: (
          <InputAdornment position="end">
        <PhoneIcon sx={{ color: "#206ccc", fontSize: 20 }} />
      </InputAdornment>
      )
    }
  }}
            onChange={this.myChangeHandler}
            value={this.state.contactnumber}
          /> </p>  </div>	   <div className="txtprojfrmryt"> <p>Email</p> 
          <p> <TextField
            
            name="emailid"
            label="Email"
            fullWidth  className="inputcntlparent" size="small"
			 
			 		
	 slotProps={{
    htmlInput: {
      maxLength: 150,
      tabIndex: 4
    },
    input: {
      endAdornment: (
          <InputAdornment position="end">
       <EmailIcon sx={{ color: "#206ccc", fontSize: 20 }} />
      </InputAdornment>
      )
    }
  }}
            onChange={this.myChangeHandler}
            value={this.state.emailid}
          /></p>  </div>  <div className="clear"></div>	
		  
		    <div className="txtprojfrm"> <p>Alt Contact Person</p> 
          <p> <TextField
     
            name="altcontactname"
            label="Alt Contact Person"
            fullWidth className="inputcntlparent" size="small"
			 
			 slotProps={{
    htmlInput: {
      maxLength: 150,
      tabIndex: 5
    },
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <ContactPhoneIcon sx={{ color: "#206ccc", fontSize: 20 }} />
        </InputAdornment>
      )
    }
  }}  
            onChange={this.myChangeHandler}
            value={this.state.altcontactname}
          /></p>  </div> 
		  <div className="txtprojfrmryt"> <p>Alt Phone</p> 
          <p> <TextField
           className="inputcntlparent" size="small"
            name="phoneno"
            label="Alt Phone"
            fullWidth 		 
	 slotProps={{
    htmlInput: {
      maxLength: 10,
      tabIndex: 6
    },
    input: {
      endAdornment: (
          <InputAdornment position="end">
        <PhoneIcon sx={{ color: "#206ccc", fontSize: 20 }} />
      </InputAdornment>
      )
    }
  }}
            onChange={this.myChangeHandler}
            value={this.state.phoneno}
          /></p>  </div> <div className="clear"></div>
         <div className="txtprojfrm"> <p>Amount</p>  <p>  <TextField
            size="small"
            name="amount"
            label="Amount" 		className="inputcntlparent" 
            fullWidth  slotProps={{
    htmlInput: {
     
      tabIndex: 7
    },
    input: {
      endAdornment: (
          <InputAdornment position="end" sx={{
          alignSelf: "flex-start",  
          mt: "6px"                 
        }}>
        <CurrencyRupeeIcon    sx={{ color: "#206ccc", fontSize: 20 }} />
      </InputAdornment>
      )
    }
  }}
            onChange={this.myChangeHandler}
            value={this.state.amount}
          /></p>  </div>
		  <div className="txtprojfrmryt"> <p>Margin (in %)</p>  <p>  <TextField
  size="small"
  name="pj_margin"
  label="Margin"
  fullWidth className="inputcntlparent" 
  slotProps={{
    htmlInput: {
     maxLength:3,
      tabIndex: 4
    },
    input: {
      endAdornment: (
          <InputAdornment position="end" sx={{
          alignSelf: "flex-start",  
          mt: "6px"                 
        }}>
        <MarginIcon   sx={{ color: "#206ccc", fontSize: 20 }} />
      </InputAdornment>
      )
    }
  }}
  onChange={this.myChangeHandler}
  value={this.state.pj_margin}
/></p>  </div> <div className="clear"></div>

  <div className="txtprojfrm"> <p>Address</p>  <p><TextField
            size="small"
            name="address"
            label="Address"
            fullWidth multiline
			className="inputcntlparent" 
			 slotProps={{
    htmlInput: {
     
      tabIndex: 9
    },
    input: {
      endAdornment: (
          <InputAdornment position="end" sx={{
          alignSelf: "flex-start",  
          mt: "6px"                 
        }}>
        <LocationOnIcon   sx={{ color: "#206ccc", fontSize: 20 }} />
      </InputAdornment>
      )
    }
  }}
            onChange={this.myChangeHandler}
            value={this.state.address}
          /> </p>  </div> <div className="clear"></div>
      
        {/* WAGE MODULE */}
      
          <h3>Labour Wages</h3>
        
        <Collapse in={this.state.erropenwag}>
          <Alert
            severity="error"
            action={
              <IconButton onClick={() => this.setState({ erropenwag: false })}>
                <CloseIcon />
              </IconButton>
            }
          >
            {this.state.errormessagewag}
          </Alert>
        </Collapse>
       
            {/* AMOUNT */}
           
          
          
         
          {/* MUI TABLE */}
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><b>Category</b></TableCell>
                  <TableCell><b>Amount</b></TableCell>
				  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.projectWages.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No wage records added
                    </TableCell>
                  </TableRow>
                ) : (
                  this.state.projectWages.map((row, i) => (
                    <TableRow key={i}>
					
					
			
               <TableCell>
			   
						 {row.wc_id === 0 && (

    <Autocomplete
  options={this.state.wageCategoryarrauto}
  value={this.state.selectedWageCategory}
  onChange={this.onWageCategoryChange}
  getOptionLabel={(option) => option?.title || ""}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Search Category"
      onChange={this.onloadWageCategoryBind}
    />
  )}
  fullWidth
/>
			 )}		 
			   
			   
  {row.wc_id === "4"
    ? "Mastri"
    : (this.state.wageCategories.find(
        (c) => String(c.wc_id) === String(row.wc_id)
      )?.wc_categoryname )}
</TableCell>
                      <TableCell>
					   {row.wc_id === 0 ? (
					   
					    <TextField
              size="small"
              type="number"
              placeholder="Amount"
              value={this.state.selectedAmount}
              onChange={this.handleAmountChange}
            />
					   
					   ):(row.amount)}
					  
					  </TableCell>
				<TableCell align="left">
  <div className="actionbtns">
  {row.wc_id === 0 ? (
  <Button variant="contained" onClick={this.addWageRow}>
    Add
  </Button>
) : (row.wc_id !== 4 && row.wc_id !== 5) ? (
  <>
    <Button
      variant="contained"
      className="editbtn"
      onClick={() => this.editWageRow(i)}
      endIcon={<EditIcon />}
    >
      
    </Button>
    &nbsp;
    <Button
      variant="contained"
      className="deletebtn"
      onClick={() => this.deleteWageRow(i)}
      endIcon={<DeleteIcon />}
    >
      
    </Button>
  </>
) : (
  // wc_id is 4 or 5
  <Button
    variant="contained"
    className="editbtn"
    onClick={() => this.editWageRow(i)}
    endIcon={<EditIcon />}
  >
    
  </Button>
)}
	
  </div>
</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
      
  <h3 style={{ marginBottom: "10px" }}>Assign Mastri</h3>
 
  
   <Collapse in={this.state.erropenmas}>
          <Alert
            severity="error"
            action={
              <IconButton onClick={() => this.setState({ erropenmas: false })}>
                <CloseIcon />
              </IconButton>
            }
          >
            {this.state.errormessagemas}
          </Alert>
        </Collapse>
  
   <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><b>Name</b></TableCell>
                <TableCell><b>Status</b></TableCell>
				  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.Asignmastri.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No wage records added
                    </TableCell>
                  </TableRow>
                ) : (
                  this.state.Asignmastri.map((row, i) => (
                    <TableRow key={i}>
					
					
			
               <TableCell>
			   
						 {row.am_id === 0 ? (

    <Autocomplete
    
    options={this.state.vendorMastriAuto}
    value={this.state.selectedMastri}
    onChange={this.onMastriChange}
    getOptionLabel={(option) => option?.title || ""}
    renderInput={(params) => (
      <TextField
        {...params}
        size="small"
        placeholder="Search Mastri"
        onChange={this.onloadVendorMastriBind}
      />
    )}
  />
			 ):(row.am_name)}		 
			   
			   
 
</TableCell><TableCell align="left">

 {row.am_active === "1"? (
 <>Inactive</>
 ):(row.am_active === "0")?( <>Active</>): null}
      </TableCell>                
				<TableCell align="left">
  <div className="actionbtns">
   {row.am_id === 0? (
  <Button variant="contained" onClick={this.handleAddMastri }>
    Add
  </Button>
): row.am_new === "0" ? (
  <>
  
   
    <Button
      variant="contained"
      className="deletebtn"
      onClick={() => this.deletemastri(i)}
      endIcon={<DeleteIcon />}
    >      
    </Button>
  </>
) :null}
	
  </div>
</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

    <br/>
       <p className="aligncenter">
          <Button variant="contained" onClick={this.handleSave} className="frmPrimarybtn">
            Save
          </Button>
       </p>
      </>
    );
  }
}